/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "0551986c19d6568aaccce587ca10cb13cc47b1d9";
